import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import { MinigridList } from "../../../features/minigrid/components/MinigridList";
import styles from "./MinigridListPage.module.scss";

export default function MinigridListPage() {
  return (
    <div className={styles["page-container"]}>
      <HeaderTitleContent>Minigrid</HeaderTitleContent>
      <div className={styles["header-page"]}>
        <MinigridList.CreatNewMinigrid />
        <div className={styles["header-page__search"]}>
          <MinigridList.SearchInput />
        </div>
      </div>
      <MinigridList.Map />
      <MinigridList.List />
    </div>
  );
}
